    function iWishCounter() {
       try{
         if (typeof iWish !== 'undefined' ){
            if(iWish.getCounter() <= 0){
              document.querySelectorAll(".iw-count-show").forEach((elm) => {
                elm.style.display = 'none';
              })
            }
            else{
              document.querySelectorAll(".iw-count-show").forEach((elm) => {
                elm.style.display = 'inline-block';
              })
            }
          }
       }
       catch(error){
         //console.log(error);
       }
      }
     function iWishRemoveFn(vId){
      try{
        iWishCounter();
      }
      catch(error){
        //console.log(error);
      }
     }
     function iWishAddFn(vId){
       try{
        iWishCounter();
      }
      catch(error){
        //console.log(error);
      }
     }
    function iWishinitFn(){
      try{
      iWishCounter();
        iWishData.money_format = "${{amount}} "+ Shopify.currency.active;
      }
      catch(error){
        //console.log(error);
      }
    }